function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logout-2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "logout-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "logout-2",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.76301227,18.4813813 L3.64963595,18.4813813 C2.25999584,18.4813813 1.13247348,17.3496984 1.13247348,15.9642188 L1.13247348,3.64052424 C1.13247348,2.25088413 2.26415644,1.12336176 3.64963595,1.12336176 L8.84622426,1.12336176 C9.15826919,1.12336176 9.40790514,0.873725817 9.40790514,0.561680882 C9.40790514,0.249635948 9.15826919,0 8.84622426,0 L3.64963595,0 C1.64006657,0 0.00911171209,1.63511546 0.00911171209,3.64052424 L0.00911171209,15.9642188 C0.00911171209,17.9737882 1.64422717,19.6047431 3.64963595,19.6047431 L8.76301227,19.6047431 C9.07505721,19.6047431 9.32469316,19.3551071 9.32469316,19.0430622 C9.32469316,18.7310173 9.07089661,18.4813813 8.76301227,18.4813813 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.0161847,9.40711462 L14.4463907,5.83732057 C14.2258789,5.61680882 13.872228,5.61680882 13.6517162,5.83732057 C13.4312045,6.05783233 13.4312045,6.41148325 13.6517162,6.63199501 L16.2645725,9.24485126 L4.86869149,9.24485126 C4.55664656,9.24485126 4.30701061,9.49448721 4.30701061,9.80653214 C4.30701061,10.1185771 4.55664656,10.368213 4.86869149,10.368213 L16.2645725,10.368213 L13.6517162,12.9810693 C13.4312045,13.201581 13.4312045,13.555232 13.6517162,13.7757437 C13.7598918,13.8839193 13.9055128,13.9421677 14.0469732,13.9421677 C14.1884335,13.9421677 14.3340545,13.8880799 14.4422301,13.7757437 L18.0120241,10.2059497 C18.2366965,9.9812773 18.2366965,9.62346578 18.0161847,9.40711462 Z",
  id: "Shape"
})));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.ac189f30.svg";
export { ForwardRef as ReactComponent };